import React, { useState, useRef, useEffect } from "react";
import LoadingSpinner from "../layouts/loading.container";
import axios from "axios";
import LocationContainer from "../moduls/location.container";

interface Spin360Props {
  imageUrls: any; // Array de URLs de las imágenes
  /* isSelectedAmenities: string; */
  frame: any;
  setFrame: any;
  isMomentDay: any;
  vista: string;
  isShowAsoleacion: any;
  /* subMenuSelected: string;
  menuSelected: string; */
}
declare const window: any;

interface DragInfo {
  x: number;
}

const movementThreshold = 1; // Umbral de movimiento para considerar el cambio de imagen
const imagesToRotateMultiplier = 0.1; // Multiplicador para ajustar la velocidad del giro

const SpinAsoleacionVista2Container: React.FC<Spin360Props> = ({
  imageUrls,
  /* isSelectedAmenities, */
  frame,
  setFrame,
  isMomentDay,
  vista,
  isShowAsoleacion
  /* subMenuSelected,
  menuSelected, */
}) => {
  //const [cachedImages, setCachedImages] = useState<string[]>([]);
  const [cachedImages, setCachedImages] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [dragStart, setDragStart] = useState<DragInfo | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [smoothedMovementX, setSmoothedMovementX] = useState(0);
  const [changeAmenities, setchangeAmenities] = useState("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [loading, setLoading] = useState(true);
  const [imageAvailable, setImageAvailable] = useState<boolean[]>([]);

  /* useEffect(() => {
    if (imageUrls) {
      setCachedImages(prevCachedImages => [...prevCachedImages, ...imageUrls]);
    }
  }, [imageUrls]); */

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  }, [screenWidth, setScreenHeight]);

  useEffect(() => {
    //if (isSelectedAmenities !== "") {
    setCurrentImageIndex(frame - 1);
    //setchangeAmenities(isSelectedAmenities);
    //setFrame(frame);
    const targetIndex = frame - 1;
    const start = performance.now();
    const duration = 3000; // Duración de la animación en milisegundos

    const animate = (timestamp) => {
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / duration, 1); // Limita el progreso a 1 para asegurarnos de que la animación termine
      const easedProgress = easeInOutQuad(progress); // Aplica una función de easing para suavizar la animación

      // Calcula la posición intermedia entre la imagen actual y la imagen de destino
      const interpolatedIndex = Math.round(
        currentImageIndex + (targetIndex - currentImageIndex) * easedProgress
      );

      setCurrentImageIndex(interpolatedIndex);

      if (progress < 1) {
        // Sigue animando si no hemos alcanzado el final de la animación
        requestAnimationFrame(animate);
      } else {
        setFrame(frame); // Una vez finalizada la animación, actualiza el frame
      }
    };

    // Comienza la animación
    requestAnimationFrame(animate);
    //}
  }, [isMomentDay]);

  useEffect(() => {
    //if (isSelectedAmenities !== "") {
    //console.log(frame);
    
    setCurrentImageIndex(frame - 1);
    //}
  }, [frame]);

  /* useEffect(() => {
    setCurrentImageIndex(frame - 1);
    setchangeAmenities(isSelectedAmenities);
    setFrame(frame);
  }, [menuSelected, subMenuSelected]); */

  useEffect(() => {
    const targetIndex = frame - 1;
    const start = performance.now();
    const duration = 500; // Duración de la animación en milisegundos

    const animate = (timestamp) => {
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / duration, 1); // Limita el progreso a 1 para asegurarnos de que la animación termine
      const easedProgress = easeInOutQuad(progress); // Aplica una función de easing para suavizar la animación

      // Calcula la posición intermedia entre la imagen actual y la imagen de destino
      const interpolatedIndex = Math.round(
        currentImageIndex + (targetIndex - currentImageIndex) * easedProgress
      );

      setCurrentImageIndex(interpolatedIndex);

      if (progress < 1) {
        // Sigue animando si no hemos alcanzado el final de la animación
        requestAnimationFrame(animate);
      } else {
        setFrame(frame); // Una vez finalizada la animación, actualiza el frame
      }
    };

    // Comienza la animación
    requestAnimationFrame(animate);
  }, [changeAmenities]);

  // Función de easing para suavizar la animación
  const easeInOutQuad = (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (dragStart !== null) {
        const movementX = e.clientX - dragStart.x;
        // Aplicar un filtro de paso bajo al movimiento del ratón
        setSmoothedMovementX(smoothedMovementX * 0.9 + movementX * 0.1);
        setDragStart({ x: e.clientX });
      }
    };
    const handleTouchMove = (e: TouchEvent) => {
      if (dragStart !== null) {
        const movementX = e.touches[0].clientX - dragStart.x;
        // Aplicar un filtro de paso bajo al movimiento del ratón
        setSmoothedMovementX(smoothedMovementX * 2 + movementX * 0.1);
        setDragStart({ x: e.touches[0].clientX });
      }
    };

    const handleMouseUp = () => {
      setDragStart(null);
    };

    const handleTouchUp = () => {
      setDragStart(null);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);

      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchUp);
    };
  }, [dragStart, smoothedMovementX]);

  const handleTouchDown = (e: React.TouchEvent<HTMLDivElement>) => {
    setDragStart({ x: e.touches[0].clientX });
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setDragStart({ x: e.clientX });
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (dragStart !== null) {
      const movementX = e.clientX - dragStart.x;
      const containerWidth = containerRef.current?.offsetWidth || 0;
      const imagesCount = imageUrls?.length;

      let imagesToRotate = Math.floor(
        Math.abs(movementX) * imagesToRotateMultiplier
      );

      if (imagesToRotate < 1) {
        imagesToRotate = 1;
      }

      let newIndex = currentImageIndex - Math.sign(movementX) * imagesToRotate;

      if (newIndex < 0) {
        newIndex = imagesCount + (newIndex % imagesCount);
      } else {
        newIndex %= imagesCount;
      }

      setCurrentImageIndex(newIndex);
      setFrame(newIndex + 1);
    }
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (dragStart !== null && e.touches.length > 0) {
      const touch = e.touches[0];
      const movementX = touch.clientX - dragStart.x;
      const containerWidth = containerRef.current?.offsetWidth || 0;
      const imagesCount = imageUrls?.length;

      let imagesToRotate = Math.floor(
        Math.abs(movementX) * imagesToRotateMultiplier
      );

      if (imagesToRotate < 1) {
        imagesToRotate = 1;
      }

      let newIndex = currentImageIndex - Math.sign(movementX) * imagesToRotate;

      if (newIndex < 0) {
        newIndex = imagesCount + (newIndex % imagesCount);
      } else {
        newIndex %= imagesCount;
      }

      setCurrentImageIndex(newIndex);
      setFrame(newIndex + 1);
    }
  };

  const handleMouseUp = () => {
    setDragStart(null);
  };

  const handleTouchUp = () => {
    setDragStart(null);
  };

  useEffect(() => {
    const checkCachedImages = async () => {
      let cont: number = 0;
      
      //console.log("Iniciando la verificación de imágenes en caché...");
      
      for (const imageUrl of imageUrls) {
        await new Promise<void>((resolve) => {
          const image = new Image();
          image.src = `https://d1bsymnertnea6.cloudfront.net/${imageUrl}`;
          
          image.onload = () => {
            cont++;
            setCachedImages(cont);  // Actualiza el estado después de cada imagen cargada
            //console.log(`Imagen cargada: ${imageUrl}`);
            resolve();
          };
          
          image.onerror = (error) => {
            console.error(`Error cargando imagen: ${imageUrl}`, error);
            resolve(); // Continúa con la siguiente imagen incluso si hay un error
          };
        });
      }
      
      //console.log(`Total de imágenes cargadas correctamente: ${cont}`);
      // Aquí puedes agregar la lógica para almacenar en localStorage si es necesario
    };
  
    checkCachedImages();
  }, [imageUrls]);
  
  // Para depurar:
  /* console.log("Imágenes en caché:", cachedImages);
  console.log("Total de URLs de imágenes:", imageUrls.length); */
//console.log(cachedImages, imageUrls.length, isShowAsoleacion);


  return cachedImages === imageUrls.length ? (
    <div className={`spin-container ${vista} `} style={{
      opacity: isShowAsoleacion ? 1 : 0,
      display: isShowAsoleacion && cachedImages === imageUrls.length ? "initial" : "none",
      cursor: "grab", position: "relative",
      overflow: "hidden"
    }}>
      {imageUrls.map((imageUrl, index) => {
        const fullImageUrl = `${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/"}${imageUrl}`;
        /* if (!cachedImages.includes(imageUrl)) {
          return null; // Si la imagen no está en caché, no la renderizamos
        } */
        return (
          <div
            key={index}
            style={{
              backgroundImage: `url(${fullImageUrl.replace(" ", "%20")})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              width: "100%",
              height: "100%",//screenHeight, // Ajusta la altura según tu necesidad
              visibility: index === currentImageIndex ? "visible" : "hidden",
              position: index === currentImageIndex ? "initial" : "absolute",
              backgroundPosition: "center 50%",
              top: 0,
              left: 0,
            }}
          />
        );
      })}
    </div>
  ) : <LoadingSpinner logo="./UI/asoleacion/modalIcon.svg" isLoading={isShowAsoleacion} />;

};

export default SpinAsoleacionVista2Container;
